import { Outlet } from 'react-router-dom';
import Header from '../ui/Header';
import History from '../history/History';
import { ToastContainer } from 'react-toastify';

const GuideLayout = () => {
	return (
		<div className='flex flex-col min-h-screen'>
			<Header showSecondaryButton={true} title='Chat' />

			<div className='flex flex-1'>
				<div className='border-r border-tertiary bg-white'>
					<History />
				</div>
				<div className='flex flex-col flex-1'>
					<ToastContainer className='mt-16' />
					<Outlet />
				</div>
			</div>
		</div>
	);
};

export default GuideLayout;
